import React from "react";
import Header from "../../../layouts/header/Header";
import Footer from "../../../layouts/footer/Footer";
import UnderMaintenanceSvg from "../../../icons/UnderMaintenanceSvg";

export const UnderMaintenance = () => {
  return (
    <>
      <Header />
      <div className="flex flex-col items-center px-customPaddingMobile mt-[40px] lg:mt-[120px]">
        <UnderMaintenanceSvg />
        <p className=" md:mt-6 text-center font-openSans font-bold text-mobile-h3 md:text-[38px] leading-8 mobile:leading-[51px] text-brand-bgBlack">
          We are under maintenance
        </p>
        <p className="text-center text-mobile-body-sm max-w-[300px] md:max-w-[390px] font-openSans font-normal md:text-web-body-lg leading-[22px] text-brand-textGrey mt-3 mobile:mt-0  md:mt-7">
          Our site is under maintenance, we will be back shortly. we are sorry
          for the inconvenience
        </p>
      </div>{" "}
      <Footer />
    </>
  );
};

export default UnderMaintenance;
